<template>
  <div class="tech_view-subsection">
      <footer class="tech_footer">
          <div class="tech_rectangle" />
          <div class="tech_footer-content">
              <div class="tech_logo-section">
                  <div class="tech_element-2">
                      <img
                          class="tech_image"
                          alt="Logo"
                          src="@/assets/cdn-animaapp/logo-3.svg"
                      />
                      <!-- <div class="tech_text-wrapper-14">АКАДЕМИЯ</div> -->
                  </div>
                  <div class="tech_text-wrapper-15">Система онлайн обучения</div>
              </div>
              <div class="tech_view">
                  <div class="tech_div">
                      <div class="tech_text-wrapper-2">Направления обучения</div>
                      <a 
                          v-for="item in educationLinks" 
                          :key="item.text"
                          href="#"
                          class="tech_text-wrapper-3"
                          @click.prevent="handleNavClick(item)"
                      >
                          {{ item.text }}
                      </a>
                  </div>
                  <div class="tech_group-2">
                      <div class="tech_text-wrapper-7">Академия</div>
                      <a 
                          v-for="item in academyLinks" 
                          :key="item.text"
                          href="#"
                          class="tech_text-wrapper-8"
                          @click.prevent="handleNavClick(item)"
                      >
                          {{ item.text }}
                      </a>
                  </div>
                  <div class="tech_group-3">
                      <div class="tech_text-wrapper-7">Контакты</div>
                      <a
                          class="tech_text-wrapper-12"
                          :href="`mailto:${contacts.email}`"
                          rel="noopener noreferrer"
                          target="_blank"
                      >
                          {{ contacts.email }}
                      </a>
                      <a
                          class="tech_text-wrapper-13"
                          :href="`tel:${contacts.phoneRaw}`"
                          rel="noopener noreferrer"
                          target="_blank"
                      >
                          {{ contacts.phone }}
                      </a>
                      <a
                          class="tech_text-wrapper-address"
                          :href="contacts.mapUrl"
                          rel="noopener noreferrer"
                          target="_blank"
                      >
                          {{ contacts.address }}
                      </a>
                  </div>
              </div>
          </div>
          <p class="tech_element">
              <span class="tech_text-wrapper">© {{ currentYear }} </span>
            <span class="tech_span">{{ companyName }}</span>
          </p>
          
          <button 
              v-show="showScrollTop"
              class="tech_scroll-top"
              @click="scrollToTop"
              title="Наверх"
          >
              ↑
          </button>
      </footer>
  </div>
</template>

<script>
export default {
  name: 'ViewSubsection',
  
  data() {
      return {
          showScrollTop: false,
          currentYear: new Date().getFullYear(),
          
          companyName: ' ООО «МЕТАЛЛ ТРЕЙД»',
          companyUrl: 'https://project.metall-trade.ru/',
          
          contacts: {
              email: 'project@metall-trade.ru',
              phone: '+7 (495) 136-25-15',
              phoneRaw: '+74951362515',
              address: 'г. Москва, Новоостаповская улица, 5с14',
              mapUrl: 'https://yandex.ru/maps/-/CDaZfV~r'
          },
          
          educationLinks: [
              { text: 'Управление и бизнес', url: '/courses/management' },
              { text: 'Аналитика и финансы', url: '/courses/analytics' },
              { text: 'Бухгалтерия', url: '/courses/accounting' },
              { text: 'Маркетинг', url: '/courses/marketing' }
          ],
          
          academyLinks: [
              { text: 'Главная', url: '/' },
              { text: 'О нас', url: '/about' },
              { text: 'Карьера', url: '/career' },
              { text: 'Privacy Policy', url: '/privacy' }
          ]
      }
  },
  
  mounted() {
      window.addEventListener('scroll', this.handleScroll)
  },
  
  beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll)
  },
  
  methods: {
      handleScroll() {
          this.showScrollTop = window.scrollY > 300
      },
      
      scrollToTop() {
          window.scrollTo({
              top: 0,
              behavior: 'smooth'
          })
      },
      
      handleNavClick(item) {
          console.log('Клик по ссылке:', item.text, item.url)
          this.$emit('nav-click', item)
      }
  }
}
</script>

<style scoped>
.tech_view-subsection {
  display: flex;
  position: relative;
  width: 100%;
  margin-top: 80px;
}

.tech_view-subsection .tech_footer {
  background-color: #2d2d2d;
  position: relative;
  width: 100%;
  min-height: 600px;
  padding: 120px 165px 100px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tech_view-subsection .tech_rectangle {
  display: none;
}

.tech_footer-content {
  display: flex;
  gap: 100px;
  align-items: flex-start;
  margin-bottom: auto;
  max-width: 1400px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.tech_logo-section {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 130px;
  flex-shrink: 0;
}

.tech_view-subsection .tech_element {
  color: #797979;
  font-family: 'Poppins', Helvetica;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.88px;
  line-height: normal;
  text-align: center;
  margin: 0;
  padding-top: 40px;
}

.tech_view-subsection .tech_text-wrapper {
  letter-spacing: 0.19px;
}

.tech_view-subsection .tech_span {
  letter-spacing: 0.19px;
  color: #797979;
  text-decoration: none;
  transition: color 0.3s ease;
}

.tech_view-subsection .tech_view {
  display: flex;
  gap: 80px;
  flex: 1;
  justify-content: space-between;
  max-width: 1000px;
}

/* ===== КОЛОНКА "Направления обучения" ===== */
.tech_view-subsection .tech_div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.tech_view-subsection .tech_text-wrapper-2 {
  color: #ffffff;
  font-family: 'Poppins', Helvetica;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.88px;
  line-height: 1.4;
  white-space: nowrap;
  margin-bottom: 0;
}

.tech_view-subsection .tech_text-wrapper-3 {
  display: block;
  color: #797979;
  font-family: 'Poppins', Helvetica;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0.88px;
  line-height: 1.4;
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
}

.tech_view-subsection .tech_text-wrapper-3:hover {
  color: #ffffff;
}

/* ===== КОЛОНКА "Академия" ===== */
.tech_view-subsection .tech_group-2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.tech_view-subsection .tech_text-wrapper-7 {
  color: #ffffff;
  font-family: 'Poppins', Helvetica;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.88px;
  line-height: 1.4;
  white-space: nowrap;
  margin-bottom: 0;
}

.tech_view-subsection .tech_text-wrapper-8 {
  display: block;
  color: #797979;
  font-family: 'Poppins', Helvetica;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0.88px;
  line-height: 1.4;
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
}

.tech_view-subsection .tech_text-wrapper-8:hover {
  color: #ffffff;
}

/* ===== КОЛОНКА "Контакты" ===== */
.tech_group-3 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.tech_view-subsection .tech_text-wrapper-12,
.tech_view-subsection .tech_text-wrapper-13,
.tech_view-subsection .tech_text-wrapper-address {
  display: block;
  color: #797979;
  font-family: 'Poppins', Helvetica;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0.88px;
  line-height: 1.4;
  text-decoration: none;
  transition: color 0.3s ease;
  white-space: nowrap;
}

.tech_view-subsection .tech_text-wrapper-12:hover,
.tech_view-subsection .tech_text-wrapper-13:hover,
.tech_view-subsection .tech_text-wrapper-address:hover {
  color: #ffffff;
}

/* ===== ЛОГО ===== */
.tech_view-subsection .tech_element-2 {
  position: relative;
  width: 129px;
  height: 72px;
}

.tech_view-subsection .tech_text-wrapper-14 {
  color: #ffffff;
  font-family: 'Prosto One', Helvetica;
  font-size: 9px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  bottom: 0;
  right: 0;
  text-align: right;
}

.tech_view-subsection .tech_image {
  width: 129px;
  height: 63px;
  display: block;
}

.tech_view-subsection .tech_text-wrapper-15 {
  color: #ffffff;
  font-family: 'Poppins', Helvetica;
  font-size: 9.5px;
  font-weight: 500;
  letter-spacing: 0.38px;
  line-height: normal;
  text-align: center;
}

/* ===== КНОПКА НАВЕРХ ===== */
.tech_scroll-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #2d2d2d;
  color: #ffffff;
  border: 2px solid #797979;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1000;
  opacity: 0.8;
}

.tech_scroll-top:hover {
  opacity: 1;
  border-color: #ffffff;
}

/* ===== АДАПТИВНОСТЬ ===== */

/* Большие экраны (до 1600px) */
@media (max-width: 1600px) {
  .tech_view-subsection .tech_footer {
      padding: 100px 120px 80px;
  }
  
  .tech_footer-content {
      gap: 80px;
  }
  
  .tech_view-subsection .tech_view {
      gap: 60px;
  }
}

/* Средние экраны (до 1400px) */
@media (max-width: 1400px) {
  .tech_view-subsection .tech_footer {
      padding: 80px 80px 60px;
  }
  
  .tech_footer-content {
      gap: 60px;
  }
  
  .tech_view-subsection .tech_view {
      gap: 50px;
  }
  
  .tech_view-subsection .tech_text-wrapper-2,
  .tech_view-subsection .tech_text-wrapper-7 {
      font-size: 18px;
  }
  
  .tech_view-subsection .tech_text-wrapper-3,
  .tech_view-subsection .tech_text-wrapper-8,
  .tech_view-subsection .tech_text-wrapper-12,
  .tech_view-subsection .tech_text-wrapper-13,
  .tech_view-subsection .tech_text-wrapper-address {
      font-size: 16px;
  }
  
  .tech_view-subsection .tech_element {
      font-size: 18px;
  }
}

/* Планшеты (до 1200px) */
@media (max-width: 1200px) {
  .tech_view-subsection .tech_footer {
      padding: 60px 60px 50px;
  }
  
  .tech_footer-content {
      flex-direction: column;
      gap: 50px;
      align-items: center; /* Центрируем весь блок */
  }
  
  .tech_logo-section {
      align-items: center; /* Лого по центру */
  }
  
  .tech_view-subsection .tech_view {
      width: 100%;
      max-width: 800px;
      justify-content: space-between;
      margin: 0 auto;
  }
  
  /* Выравнивание колонок по левому краю */
  .tech_view-subsection .tech_div,
  .tech_view-subsection .tech_group-2,
  .tech_view-subsection .tech_group-3 {
      align-items: flex-start;
  }
  
  .tech_view-subsection .tech_text-wrapper-2,
  .tech_view-subsection .tech_text-wrapper-7,
  .tech_view-subsection .tech_text-wrapper-3,
  .tech_view-subsection .tech_text-wrapper-8,
  .tech_view-subsection .tech_text-wrapper-12,
  .tech_view-subsection .tech_text-wrapper-13,
  .tech_view-subsection .tech_text-wrapper-address {
      text-align: left;
  }
}

/* Маленькие планшеты (до 900px) */
@media (max-width: 900px) {
  .tech_view-subsection .tech_footer {
      padding: 50px 40px 40px;
  }
  
  .tech_footer-content {
      gap: 40px;
  }
  
  .tech_view-subsection .tech_view {
      flex-wrap: wrap;
      gap: 40px;
      justify-content: space-between; /* Равномерное распределение */
  }
  
  .tech_view-subsection .tech_div,
  .tech_view-subsection .tech_group-2,
  .tech_view-subsection .tech_group-3 {
      min-width: calc(50% - 20px);
      max-width: calc(50% - 20px);
      align-items: flex-start; /* Исправлено: left → flex-start */
  }
  
  /* Выравнивание текста по левому краю */
  .tech_view-subsection .tech_text-wrapper-2,
  .tech_view-subsection .tech_text-wrapper-7,
  .tech_view-subsection .tech_text-wrapper-3,
  .tech_view-subsection .tech_text-wrapper-8,
  .tech_view-subsection .tech_text-wrapper-12,
  .tech_view-subsection .tech_text-wrapper-13,
  .tech_view-subsection .tech_text-wrapper-address {
      text-align: left;
  }
}

/* Мобильные устройства (до 600px) */
@media (max-width: 600px) {
  .tech_view-subsection {
      margin-top: 40px;
  }
  
  .tech_view-subsection .tech_footer {
      min-height: auto;
      padding: 40px 20px 30px;
  }
  
  .tech_footer-content {
      gap: 30px;
      align-items: center; /* Центрируем ВСЁ содержимое футера */
  }
  
  .tech_logo-section {
      align-items: center; /* Лого по центру */
      width: 100%;
  }
  
  .tech_view-subsection .tech_view {
      flex-direction: column;
      gap: 30px;
      align-items: center; /* ЦЕНТРИРУЕМ КОЛОНКИ как блоки */
      width: 100%;
  }
  
  .tech_view-subsection .tech_div,
  .tech_view-subsection .tech_group-2,
  .tech_view-subsection .tech_group-3 {
      /* Убираем min-width: 100%, чтобы колонки могли центрироваться */
      width: auto; /* Ширина по содержимому */
      max-width: 100%; /* Но не больше экрана */
      align-items: flex-start; /* Контент ВНУТРИ колонки - слева */
      text-align: left; /* Текст слева */
  }
  
  /* Выравнивание заголовков слева на мобильных */
  .tech_view-subsection .tech_text-wrapper-2,
  .tech_view-subsection .tech_text-wrapper-7 {
      text-align: left; /* Текст слева */
      width: auto; /* Убираем width: 100% */
  }
  
  /* Выравнивание ссылок слева на мобильных */
  .tech_view-subsection .tech_text-wrapper-3,
  .tech_view-subsection .tech_text-wrapper-8,
  .tech_view-subsection .tech_text-wrapper-12,
  .tech_view-subsection .tech_text-wrapper-13,
  .tech_view-subsection .tech_text-wrapper-address {
      text-align: left; /* Текст слева */
      width: auto; /* Убираем width: 100% */
  }
  
  /* Разрешить перенос адреса на мобильных */
  .tech_view-subsection .tech_text-wrapper-address {
      white-space: normal;
      max-width: 280px; /* Ограничим ширину адреса */
  }
  
  .tech_scroll-top {
      width: 44px;
      height: 44px;
      bottom: 20px;
      right: 20px;
      font-size: 20px;
  }
  
  .tech_view-subsection .tech_element {
      font-size: 16px;
      padding-top: 30px;
  }
}
/* Очень маленькие экраны (до 400px) */
@media (max-width: 400px) {
  .tech_view-subsection .tech_footer {
      padding: 30px 15px 25px;
  }
  
  .tech_view-subsection .tech_text-wrapper-2,
  .tech_view-subsection .tech_text-wrapper-7 {
      font-size: 16px;
  }
  
  .tech_view-subsection .tech_text-wrapper-3,
  .tech_view-subsection .tech_text-wrapper-8,
  .tech_view-subsection .tech_text-wrapper-12,
  .tech_view-subsection .tech_text-wrapper-13,
  .tech_view-subsection .tech_text-wrapper-address {
      font-size: 14px;
  }
  
  .tech_view-subsection .tech_element {
      font-size: 14px;
  }
}
</style>